<template>
  <div class="min-h-screen">
    <!-- 顶部导航栏 -->
    <header class="bg-white shadow-sm fixed top-0 left-0 right-0 z-50">
      <div class="px-4 py-3 bg-gradient-to-r from-blue-50 to-blue-100">
        <div class="flex items-center">
          <a @click="$router.back()" class="text-gray-600">
            <!-- <font-awesome-icon icon="arrow-left" class="text-xl" /> -->
          </a>
          <h1 class="text-lg font-semibold text-center flex-1 mr-8 paw-pattern">监测记录</h1>
        </div>
      </div>
    </header>

    <!-- 主要内容区域 -->
    <main class="pt-16 pb-20 px-4">
      <!-- 设备选择 -->
      <div class="bg-white rounded-2xl p-5 shadow-lg mb-6" style="background: linear-gradient(135deg, #fff, var(--background-color));">
        <div class="flex items-start justify-between mb-3">
          <div>
            <div class="flex items-center space-x-3 mb-1.5">
              <h2 class="text-base font-bold">我的宠物伙伴</h2>
              <span class="text-xs text-gray-500 bg-gray-50 px-2 py-1 rounded-full">{{ deviceCount }}个设备</span>
            </div>
            <p class="text-xs text-gray-500">选择查看对应宠物的健康记录</p>
          </div>
          <router-link to="/device-list" class="flex items-center px-3 py-1 text-xs text-gray-600 bg-gray-50 hover:bg-gray-100 rounded-full transition-colors">
            <!-- <font-awesome-icon icon="cog" class="mr-1" /> -->
            <img style="width: 11px;height: 11px;" class="mr-1" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/cog-fill2.png"/>
            <span>管理</span>
          </router-link>
        </div>
        <div class="relative">
          <div class="scroll-fade scroll-fade-left"></div>
          <div class="scroll-fade scroll-fade-right"></div>
          <div class="scroll-container overflow-x-auto">
            <div class="flex gap-3 px-0.5 py-0.5">
              <div 
                v-for="(device, index) in devices" 
                :key="index"
                class="device-card flex-shrink-0 bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-3 cursor-pointer"
                :class="{ 'active': selectedDeviceIndex === index }"
                style="width: 100px;"
                @click="selectDevice(device,index)"
              >
                <div class="device-status" :class="{ 'offline': !device.online }"></div>
                <div class="flex flex-col items-center">
                  <div class="w-10 h-10 bg-white/70 backdrop-blur-sm rounded-full flex items-center justify-center mb-2 shadow-sm">
                    <img :src="device.petImage" alt="宠物头像" class="w-10 h-10 rounded-full">
                    <!-- <font-awesome-icon v-else :icon="device.type === 'dog' ? 'dog' : 'cat'" class="text-lg device-icon" :class="{ 'text-gray-500': selectedDeviceIndex !== index }" />  -->
                  </div>
                  <div class="text-xs font-medium mb-0.5">{{ device.petName }}</div>
                  <!-- <div class="text-[10px] text-gray-500 bg-white/50 px-1.5 py-0.5 rounded-full">{{ device.deviceName }}</div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 数据概览 -->
      <div class="bg-white rounded-2xl p-6 shadow-lg mb-6" style="background: linear-gradient(135deg, #fff, var(--background-color));">
        <div class="flex items-center justify-between mb-4">
          <h2 class="text-lg font-bold">数据概览</h2>
          <div @click="show = true" class="date-picker-wrapper">
            <button class="date-picker-button">
              <!-- <font-awesome-icon icon="calendar-alt" /> -->
              <img style="width: 16px;height: 16px;" class="mr-1" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/calendar-alt-solid.png"/>
              <!-- <span id="selected-date">{{ formattedSelectedDate }}</span> -->
              <span id="selected-date">{{ currentSelectedDate }}</span>
            </button>
            <!-- <input type="date" v-model="selectedDate" class="absolute"> -->
          </div>
        </div>
        <div class="grid grid-cols-2 gap-4">
          <!-- 卡路里 -->
          <div class="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4 stat-card">
            <div class="flex items-center dataCenter">
              <div style="color: var(--accent-color)">
                <img style="width: 18px;height: 18px;" class="text-xl" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/fire.png"/>
                <!-- <font-awesome-icon icon="fire" class="text-xl" /> -->
              </div>
            </div>
            <div class="mt-2">
              <div class="text-2xl font-bold stat-value">{{ petMotion.totalCalorie }}</div>
              <div class="text-sm text-gray-600">卡路里（千卡）</div>
            </div>
          </div>

          <!-- 步数 -->
          <div class="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4 stat-card">
            <div class="flex items-center dataCenter">
              <div style="color: var(--accent-color)">
                <img style="width: 25px;height: 20px;" class="text-xl" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/shoe-prints.png"/>
                <!-- <font-awesome-icon icon="shoe-prints" class="text-xl" /> -->
              </div>
            </div>
            <div class="mt-2">
              <div class="text-2xl font-bold stat-value">{{ petMotion.totalSteps }}</div>
              <div class="text-sm text-gray-600">步数</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 运动记录 -->
      <div class="bg-white rounded-2xl p-6 shadow-lg mb-6" style="background: linear-gradient(135deg, #fff, var(--background-color));">
        <h2 class="text-lg font-bold mb-4">运动记录</h2>
        <div class="space-y-4">
          <div class="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <div class="w-10 h-10 bg-white/50 rounded-full flex items-center justify-center" style="color: var(--accent-color)">
                  <!-- <font-awesome-icon icon="walking" class="text-xl" /> -->
                  <img style="width: 20px;height: 20px;" class="text-xl" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/walking.png"/>
                </div>
                <div class="ml-3">
                  <div class="font-medium">散步</div>
                </div>
              </div>
              <div class="text-right">
                <div class="font-medium stat-value">{{ petMotion.walkingTime }}</div>
                <div class="text-sm text-gray-500">{{ petMotion.walkingDistance }}</div>
              </div>
            </div>
          </div>
          <div class="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <div class="w-10 h-10 bg-white/50 rounded-full flex items-center justify-center" style="color: var(--accent-color)">
                  <!-- <font-awesome-icon icon="running" class="text-xl" /> -->
                  <img style="width: 20px;height: 20px;" class="text-xl" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/running.png"/>
                </div>
                <div class="ml-3">
                  <div class="font-medium">跑步</div>
                </div>
              </div>
              <div class="text-right">
                <div class="font-medium stat-value">{{ petMotion.runningTime }}</div>
                <div class="text-sm text-gray-500">{{ petMotion.runningDistance }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 活动图表 -->
      <div class="bg-white rounded-2xl p-6 shadow-lg" style="background: linear-gradient(135deg, #fff, var(--background-color));">
        <div class="flex items-center justify-between mb-4">
          <h2 class="text-lg font-bold">活动趋势</h2>
          <div class="flex space-x-2">
            <button 
              @click="setChartPeriod('week')" 
              class="px-3 py-1 text-sm rounded-full"
              :class="chartPeriod === 'week' ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-sm' : 'text-gray-500 hover:bg-gray-100'"
            >周</button>
            <button 
              @click="setChartPeriod('month')" 
              class="px-3 py-1 text-sm rounded-full"
              :class="chartPeriod === 'month' ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-sm' : 'text-gray-500 hover:bg-gray-100'"
            >月</button>
          </div>
        </div>
        <canvas ref="activityChart" height="200"></canvas>
      </div>
    </main>

    <van-popup position="bottom" v-model="show" round>
      <van-datetime-picker
          @confirm="confirmTime"
          @cancel="cancelTime"
          v-model="currentDate"
          title="选择时间"
          :max-date="maxDate"
          type="date"/>
        </van-popup>
    <!-- 底部导航栏 -->
    <nav class="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 shadow-lg">
      <div class="grid grid-cols-5 py-2 theme-header">
        <router-link to="/home" exact active-class="nav-active" class="routerLink">
          <!-- <font-awesome-icon icon="home" class="text-xl" /> -->
          <!-- <img style="width: 22px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/selHome.png"/> -->
          <img style="width: 22px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/home.png"/>
          <p class="text-xs mt-1">首页</p>
        </router-link>
        <router-link to="/location" exact active-class="nav-active" class="routerLink">
          <!-- <font-awesome-icon icon="map-marker-alt" class="text-xl" /> -->
          <!-- <img style="width: 22px;height: 22px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/SelPosition.png"/> -->
          <img style="width: 22px;height: 22px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/position.png"/>
          <p class="text-xs mt-1">定位</p>
        </router-link>
        <router-link to="/ai-diagnosis" exact active-class="nav-active" class="routerLink">
          <!-- <font-awesome-icon icon="robot" class="text-xl" /> -->
          <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/robotAi.png"/>
          <!-- <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/selRobotAi.png"/> -->
          <p class="text-xs mt-1">AI问诊</p>
        </router-link>
        <router-link to="/device-list" exact active-class="nav-active" class="routerLink">
          <!-- <font-awesome-icon icon="microchip" class="text-xl" /> -->
          <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/microchip.png"/>
          <!-- <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/selMicrochip.png"/> -->
          <p class="text-xs mt-1">设备</p>
        </router-link>
        <router-link to="/profile" exact active-class="nav-active" class="routerLink">
          <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/user.png"/>
          <!-- <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/selUser.png"/> -->
          <!-- <font-awesome-icon icon="user" class="text-xl" /> -->
          <p class="text-xs mt-1">我的</p>
        </router-link>
      </div>
    </nav>
  </div>
</template>

<script>
import { formatDate } from '@/utils'
import { mapGetters } from 'vuex'
import Chart from 'chart.js/auto'
import { RPC } from '@/api/rpc'
import dayjs from 'dayjs'

export default {
  name: 'Statistics',
  data() {
    return {
      maxDate: new Date(2025, 9, 1),
      show: false,
      currentDate: new Date(),
      currentSelectedDate: dayjs(new Date()).format('YYYY年MM月DD日'),
      userId: null,
      selectedDate: this.formatDateForInput(new Date()),
      selectedDeviceIndex: 0,
      chartPeriod: 'week',
      chart: null,
      devices: [
        { name: '小白', type: 'dog', deviceName: '项圈#1', online: true },
        { name: '咪咪', type: 'cat', deviceName: '项圈#2', online: true },
        { name: '旺财', type: 'dog', deviceName: '项圈#3', online: false },
        { name: '花花', type: 'cat', deviceName: '项圈#4', online: true }
      ],
      weekData: {
        labels: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
        datasets: [{
          label: '卡路里',
          data: [],
          borderColor: '#3B82F6',
          backgroundColor: 'rgba(59, 130, 246, 0.1)',
          fill: true,
          tension: 0.4
        }, {
          label: '步数',
          data: [],
          borderColor: '#93C5FD',
          backgroundColor: 'rgba(147, 197, 253, 0.1)',
          fill: true,
          tension: 0.4
        }]
      },
      monthData: {
        labels: Array.from({length: 30}, (_, i) => `${i + 1}日`),
        datasets: [{
          label: '卡路里',
          data: Array.from({length: 30}, () => Math.floor(Math.random() * (300 - 150) + 150)),
          borderColor: '#3B82F6',
          backgroundColor: 'rgba(59, 130, 246, 0.1)',
          fill: true,
          tension: 0.4
        }, {
          label: '步数',
          data: Array.from({length: 30}, () => Math.floor(Math.random() * (8000 - 4000) + 4000)),
          borderColor: '#93C5FD',
          backgroundColor: 'rgba(147, 197, 253, 0.1)',
          fill: true,
          tension: 0.4
        }]
      },
      devices: [],
      endTime: '',
      petMotion: [],
      machineId: '',
    }
  },
  computed: {
    ...mapGetters(['currentDevice']),
    deviceCount() {
      return this.devices.length;
    },
    formattedSelectedDate() {
      const date = new Date(this.selectedDate);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      this.endTime = year + '-' + month + '-' + day
      if (this.machineId) {
        this.getMotionInformation()
      }
      return `${year}年${month}月${day}日`;
    }
  },
  methods: {
    formatDate,
    confirmTime(e) {
        this.currentDate = new Date(e)
        this.currentSelectedDate = dayjs(e).format('YYYY年MM月DD日')
        this.endTime = dayjs(e).format('YYYY-MM-DD')
        if (this.machineId) {
          this.getMotionInformation()
        }
        this.show = false
    },
    cancelTime() {
      this.show = false
    },
    formatDateForInput(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    getActivityIcon(type) {
      const icons = {
        '散步': 'walking',
        '奔跑': 'running',
        '休息': 'bed'
      };
      return icons[type] || 'paw';
    },
    selectDevice(device,index) {
      this.machineId = device.machineId
      this.chartPeriod = 'week'
      this.selectedDeviceIndex = index;
      // this.getMotionInformation()
      this.getSportsTrends()
      // 这里可以添加切换设备后的数据更新逻辑
    },
    setChartPeriod(period) {
      this.chartPeriod = period;
      this.getSportsTrends()
    },
    updateChart() {
      if (this.chart) {
        this.chart.destroy();
      }
      
      const ctx = this.$refs.activityChart.getContext('2d');
      const data = this.chartPeriod === 'week' ? this.weekData : this.monthData;
      
      this.chart = new Chart(ctx, {
        type: 'line',
        data: data,
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: 'top',
            }
          },
          scales: {
            y: {
              beginAtZero: true
            }
          },
          animation: {
            duration: 750,
            easing: 'easeInOutQuart'
          }
        }
      });
    },
    getDeviceList() {
      this.userId = sessionStorage.getItem('info')?JSON.parse(sessionStorage.getItem('info')).userId : null
      let data = {
        "pageIndex": 1,
        "pageSize": 100,
        "userId": this.userId
      }
      RPC.deviceList(data).then(res=>{
        if (res.list) {
          this.devices = res.list  
          res.list.forEach((item,index)=>{
            if(item.isDefault === 1){
              this.selectedDeviceIndex = index
              this.machineId = this.backMachineId?this.backMachineId:item.machineId
            }
          })
          // this.machineId = res.list[0].machineId
          this.getSportsTrends()
        }
      })
    },
    getMotionInformation() {
      let currentTime = dayjs(this.endTime).format('YYYY-MM-DD')
      let data = {
        "endTime": currentTime + ' 23:59:59',
        "machineId": this.machineId,
        "startTime": currentTime + ' 00:00:00'
      }
      RPC.motionInformation(data).then(res=>{
        this.petMotion = res.data
      })
    },
    getSportsTrends() {
      let CalorieData = []
      let StepData = []
      let data = {
        "cycle": this.chartPeriod === 'week' ? 1 : 2,
        "machineId": this.machineId
      }
      RPC.sportsTrends(data).then(res=>{
        res.data.dataList.map(item=>{
          CalorieData.push(item.totalCalorie)
          StepData.push(item.totalSteps)
        })
        if (this.chartPeriod === 'week') {
          this.weekData.datasets[0].data = CalorieData
          this.weekData.datasets[1].data = StepData
        } else {
          this.monthData.datasets[0].data = CalorieData
          this.monthData.datasets[1].data = StepData
        }
        this.updateChart();
      })
    }
  },
  mounted() {
    this.getDeviceList()
    console.log('Statistics 页面已挂载');
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
}
</script>

<style scoped>
:root {
  --primary-color: #3B82F6;
  --secondary-color: #93C5FD;
  --accent-color: #2563EB;
  --background-color: #F3F4F6;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.stat-card {
  transition: all 0.3s ease;
  border-radius: 16px;
}

.stat-card:hover {
  transform: translateY(-2px);
}

.stat-value {
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.device-card {
  transition: all 0.3s ease;
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
}

.device-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1));
  opacity: 0;
  transition: opacity 0.3s ease;
}

.device-card:hover::before {
  opacity: 1;
}

.device-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.device-card.active {
  border-color: var(--primary-color);
  background: linear-gradient(135deg, var(--background-color), white);
}

.device-card.active .device-icon {
  color: var(--primary-color);
  transform: scale(1.1);
}

.device-icon {
  transition: all 0.3s ease;
}

.device-status {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #10B981;
  box-shadow: 0 0 0 2px white;
}

.device-status.offline {
  background: #9CA3AF;
}

.scroll-container {
  scrollbar-width: none;
  -ms-overflow-style: none;
  position: relative;
}

.scroll-container::-webkit-scrollbar {
  display: none;
}

.scroll-fade {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 24px;
  pointer-events: none;
  z-index: 1;
}

.scroll-fade-left {
  left: 0;
  background: linear-gradient(to right, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0));
}

.scroll-fade-right {
  right: 0;
  background: linear-gradient(to left, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0));
}

.progress-bar {
  height: 6px;
  border-radius: 999px;
  background: var(--background-color);
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  background: linear-gradient(to right, var(--primary-color), var(--secondary-color));
  transition: width 0.3s ease;
}

.paw-pattern {
  position: relative;
}

.paw-pattern::before {
  content: '🐾';
  position: absolute;
  top: -10px;
  right: -5px;
  font-size: 20px;
  opacity: 0.3;
  transform: rotate(30deg);
}

.date-picker-wrapper {
  position: relative;
  display: inline-block;
}

.date-picker-button {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  color: white;
  border: none;
  border-radius: 9999px;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.date-picker-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.date-picker-button svg {
  margin-right: 0.5rem;
}

/* 隐藏原生日期选择器的输入框样式 */
input[type="date"] {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

/* 禁用原生日期选择器的手动输入 */
input[type="date"]::-webkit-calendar-picker-indicator {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: auto;
  height: auto;
  color: transparent;
  background: transparent;
}

input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-clear-button {
  display: none;
}
.dataCenter {
  display: flex;
  justify-content: center;
}
.routerLink {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
</style> 